import Contracts from './contracts/Contracts'
import Payments from './dashboard/component/Payments'
import dashboard from './dashboard/Dashboard'
import VendorsList from './vendorsList/VendorsList'

export const ROUTES = [
  {
    component: dashboard,
    isPublic: true,
    path: '/vendors',
    slug: 'vendors',
    title: 'vendors',
    isProtected: true,
    showMenu: true,
    redirectTo: '/auth/login',
    isExact: true,
  },
  {
    component: Payments,
    isPublic: true,
    path: '/vendors/payments/:id',
    slug: 'vendors',
    title: 'vendors',
    isProtected: true,
    showMenu: true,
    redirectTo: '/auth/login',
    isExact: true,
  },
  {
    component: VendorsList,
    isPublic: true,
    path: '/vendors/list',
    slug: 'vendors',
    title: 'vendors',
    isProtected: true,
    showMenu: true,
    redirectTo: '/auth/login',
    isExact: true,
  },
  {
    component: Contracts,
    isPublic: true,
    path: '/vendors/contracts',
    slug: 'vendors',
    title: 'vendors',
    isProtected: true,
    showMenu: true,
    redirectTo: '/auth/login',
    isExact: true,
  },
]
